export default __webpack_public_path__ + "static/media/people-ico.53152086.svg";